module.exports = __webpack_public_path__ + "assets/marker_red.cf1ce9d9.svg";